import { EVENTS } from '@/lib/consts.js'
import { useEmitter } from '@/composables/emitter/index.js'
import { useLogger } from '@booksy-com/vue-tools'

const { emit } = useEmitter()
const logger = useLogger('event-bus')

export function modalOpen (name, data) {
  logger.info('open modal', name, data)
  return new Promise((resolve, reject) => {
    // prevent from rejecting with undefined
    const modalReject = (...args) => {

      return args.length ? reject(...args) : reject('[event-bus-modal] closed')
    }
    emit(name, { resolve, reject: modalReject, data })
  })
}

export function handleWebViewPushOpen (data) {
  logger.info(EVENTS.WEB_VIEW_PUSH_OPEN, data)
  emit(EVENTS.WEB_VIEW_PUSH_OPEN, data)
}

export function handleWebViewResume () {
  logger.info(EVENTS.WEB_VIEW_RESUME)
  emit(EVENTS.WEB_VIEW_RESUME)
}

export function appointmentCalendarEvent (name, data) {
  logger.info('store/appointment event to calendar', name, data)
  emit(name, data)
}
